import { render, staticRenderFns } from "./budget-campaign.vue?vue&type=template&id=1d5cec56"
import script from "./budget-campaign.vue?vue&type=script&lang=js"
export * from "./budget-campaign.vue?vue&type=script&lang=js"
import style0 from "./budget-campaign.vue?vue&type=style&index=0&id=1d5cec56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports